// Catálogo de los mensajes automáticos (F2 reorden 24-oct-2026; separado de la página en F3 para que Referidos y
// Membresías pinten SUS filas en una pestaña propia sin importar la página entera).
import type React from 'react';
import { HandMetal, Repeat, Share2, ThumbsDown, BatteryLow, Star, BadgeCheck } from 'lucide-react';

export type EventoClave =
  | 'welcome' | 'visit' | 'referral' | 'feedback_alert' | 'low_balance' | 'google_reviews'
  | 'membership_expiring' | 'membership_expired';

export interface FilaMensaje {
  clave: EventoClave;
  nombre: string;
  cuando: string;
  icon: React.ElementType;
  color: string;
  /** El evento solo tiene sentido si el negocio tiene encendido este módulo. */
  requiere?: 'referidos' | 'membresias';
  /** Mensaje que llega al DUEÑO, no al cliente. */
  alDueno?: boolean;
}

export const FILAS: FilaMensaje[] = [
  { clave: 'welcome', nombre: 'Bienvenida', cuando: 'Al registrarse un cliente nuevo', icon: HandMetal, color: 'text-emerald-500' },
  { clave: 'visit', nombre: 'Gracias por tu visita', cuando: 'Cada vez que un cliente suma puntos', icon: Repeat, color: 'text-emerald-500' },
  { clave: 'low_balance', nombre: 'Saldo bajo', cuando: 'Tras un canje, si el saldo queda por debajo del umbral', icon: BatteryLow, color: 'text-emerald-500' },
  { clave: 'referral', nombre: 'Aviso al que recomienda', cuando: 'Cuando su invitado se registra y se acreditan los puntos', icon: Share2, color: 'text-emerald-500', requiere: 'referidos' },
  { clave: 'google_reviews', nombre: 'Pedir reseña en Google', cuando: 'A clientes frecuentes, una sola vez, en el mejor momento', icon: Star, color: 'text-amber-500' },
  { clave: 'feedback_alert', nombre: 'Alerta de opinión', cuando: 'Cuando un cliente deja una opinión mala o neutral', icon: ThumbsDown, color: 'text-amber-500', alDueno: true },
  { clave: 'membership_expiring', nombre: 'Membresía por vencer', cuando: 'Unos días antes de que venza (o queden pocos productos)', icon: BadgeCheck, color: 'text-emerald-500', requiere: 'membresias' },
  { clave: 'membership_expired', nombre: 'Membresía vencida', cuando: 'Cuando venció o se agotó y el cliente no renovó', icon: BadgeCheck, color: 'text-amber-500', requiere: 'membresias' },
];

// Ruta vieja → clave del evento (para las redirecciones de routes.tsx y los enlaces que aún las usen).
export const RUTA_VIEJA_A_EVENTO: Record<string, EventoClave> = {
  'welcome-message': 'welcome', 'visit-message': 'visit', 'referral-message': 'referral', 'feedback-alert': 'feedback_alert',
  'low-balance-alert': 'low_balance', 'google-reviews': 'google_reviews', 'membership-expiring': 'membership_expiring', 'membership-expired': 'membership_expired',
};
